
const MAIL_SENDER = "#senderEmail";
const PHONE = "#senderPhone";

$(document).ready(function() {
    "use strict";

    // Anchor Smooth Scroll
    $('body').on('click', '.page-scroll', function(event) {
        var $anchor = $(this);
        $('html, body').stop().animate({
            scrollTop: ($($anchor.attr('href')).offset().top - 90)
        }, 1000, 'easeInOutExpo');
        event.preventDefault();
    });

    // Scrollspy
    $('body').scrollspy({
        target: ".navbar",
        offset: 105
    })

    $(MAIL_SENDER).on('change',function(){
        if($(MAIL_SENDER).val().trim() != '') {
            $(PHONE).attr('placeholder','Téléphone');
            $(PHONE)[0].required = false;
        }else{
            $(PHONE).attr('placeholder','Téléphone*');
            $(PHONE)[0].required = true;
        }
    })

    $(PHONE).on('change',function(){
        if($(PHONE).val().trim() != '') {
            $(MAIL_SENDER).attr('placeholder','Mail');
            $(MAIL_SENDER)[0].required = false;
        }else{
            $(MAIL_SENDER).attr('placeholder','Mail*');
            $(MAIL_SENDER)[0].required = true;
        }
    })
});

// Fixed Header
$(window).scroll(function() {
    var value = $(this).scrollTop();
    if (value > 90)
        $(".navbar-default").addClass('navbar-default--scroll');
    else
        $(".navbar-default").removeClass('navbar-default--scroll');
});



// WEBPACK FOOTER //
// ./source/javascript/main.js